const TOPICS = [
  { title: '热血战斗', count: '386部', desc: '燃到爆的战斗场面，主角逆袭成长之路', color: 'bg-primary-100 text-primary-700' },
  { title: '恋爱甜宠', count: '512部', desc: '高甜恋爱故事，心跳加速的浪漫邂逅', color: 'bg-accent-100 text-accent-700' },
  { title: '奇幻冒险', count: '428部', desc: '异世界穿越、魔法大陆，无限想象力', color: 'bg-secondary-100 text-secondary-700' },
  { title: '悬疑推理', count: '203部', desc: '烧脑剧情层层反转，猜不到的真相', color: 'bg-primary-100 text-primary-700' },
  { title: '搞笑日常', count: '317部', desc: '轻松解压的搞笑漫画，笑到停不下来', color: 'bg-accent-100 text-accent-700' },
  { title: 'BL/GL', count: '456部', desc: '热门耽美百合，精致画风动人故事', color: 'bg-secondary-100 text-secondary-700' },
  { title: '完结精选', count: '892部', desc: '一口气读完的完结佳作，不用等更新', color: 'bg-primary-100 text-primary-700' },
  { title: '新番上架', count: '本周+24', desc: '最新上架的漫画作品，新鲜抢先看', color: 'bg-accent-100 text-accent-700' },
];

export default function TopicIndex() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门专题合集
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            按品类与主题快速发现心仪漫画，八大专题任你探索
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {TOPICS.map((t, i) => (
            <a
              key={i}
              href="#index"
              className="group p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer no-underline flex flex-col"
            >
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {t.title}
                </h3>
                <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${t.color}`}>
                  {t.count}
                </span>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed">{t.desc}</p>
              <div className="mt-3 flex items-center gap-1 text-xs text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity">
                <span>浏览专题</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}